import BaseStreemTooltip from "./BaseStreemTooltip.vue";

export * from "./BaseStreemTooltip.vue";
export default BaseStreemTooltip;
